import { render, staticRenderFns } from "./AllDestinationsCard.vue?vue&type=template&id=4bf60f18&scoped=true"
import script from "./AllDestinationsCard.vue?vue&type=script&lang=js"
export * from "./AllDestinationsCard.vue?vue&type=script&lang=js"
import style0 from "./AllDestinationsCard.vue?vue&type=style&index=0&id=4bf60f18&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bf60f18",
  null
  
)

export default component.exports